module.exports = {
  "dof-body": {
    "flex": 1
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-40fddc71!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-date-cycle-picker/index.vue
// module id = 468
// module chunks = 0 1